<mat-card class="flex flex-column">
  <mat-card-header>
    <mat-card-title class="flex self-center">Erreur Technique @if (errorId) {
      n° {{errorId}}
    }
  </mat-card-title>
</mat-card-header>
<mat-card-actions class="flex self-center">
  <button mat-button type="button" (click)="reloadApp()" color="primary">Vers l'écran d'accueil</button>
</mat-card-actions>
</mat-card>
